import { s16, s4, s8 } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import { BAR_COLOR } from './const';
import type { DragAndDropOrientation, Position } from './types';

const dot = css`
  &::before {
    position: absolute;
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${BAR_COLOR};
    content: ' ';
  }
`;

const OVERLAY_INDICATOR_WIDTH = '3px';

const getOverlayIndicatorOffset = (gapSize: string) =>
  `calc(-1 * (${gapSize} + ${OVERLAY_INDICATOR_WIDTH}) / 2)`;

export const OverlayDropIndicator = styled.div<{
  $position: Position;
  $gapSize: string;
}>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: ${OVERLAY_INDICATOR_WIDTH};
  border-radius: 5px;
  background-color: ${BAR_COLOR};
  pointer-events: none;
  ${({ $position, $gapSize }) =>
    $position === 'before'
      ? css`
          left: ${getOverlayIndicatorOffset($gapSize)};
        `
      : css`
          right: ${getOverlayIndicatorOffset($gapSize)};
        `}
`;

export const DropPlaceholderBar = styled.div<{
  $orientation?: DragAndDropOrientation;
  $showDot?: boolean;
}>`
  position: relative;
  ${({ $orientation = 'vertical', $showDot = true }) =>
    $orientation === 'horizontal'
      ? css`
          align-self: stretch;
          border-left: 3px solid ${BAR_COLOR};
          border-radius: 5px;
          margin: ${s4} ${s8};
          ${
            $showDot &&
            css`
              ${dot}
              &::before {
                top: 0;
                left: -3px;
              }
            `
          }
        `
      : css`
          border-bottom: 3px solid ${BAR_COLOR};
          border-radius: 5px;
          margin: ${s8} ${s16};
          ${
            $showDot &&
            css`
              ${dot}
              &::before {
                left: 0;
                top: -3px;
              }
            `
          }
        `}
`;
